import {
  all,
  takeEvery,
  put,
  fork,
  call,
  takeLatest,
} from 'redux-saga/effects';
import {
  AUTH_TOKEN,
  ACCESS_TOKEN,
  SIGNIN,
  SIGNOUT,
  SIGNUP,
  SIGNIN_WITH_GOOGLE,
  SIGNIN_WITH_FACEBOOK,
  SIGNIN_WITH_EMAIL,
  GENERATE_QR,
  VERIFY_UNIQUE_KEY,
  IS_2FA_ENABLED,
  EMAIL,
  GET_IS_2FA_ENABLED,
  CHANGE_PASSWORD,
  GET_USER_PROFILE,
} from '../constants/Auth';
import {
  showAuthMessage,
  authenticated,
  signOutSuccess,
  signInWithGoogleAuthenticated,
  signInWithFacebookAuthenticated,
  signInWithEmailAuthenticated,
  setQR,
  userVerified,
  setIs2FAEnabled,
  signOut,
  setLoading,
  setUserProfile,
} from '../actions/Auth';
import {
  fetchRequested,
  fetchCompleted,
  displayMessage,
} from 'redux/actions/Ui';
import axios from 'axios';
import FirebaseService from 'services/FirebaseService';
import { env } from 'configs/EnvironmentConfig';
import Cookies from 'universal-cookie';

export function* signInWithFBEmail() {
  yield takeEvery(SIGNIN, function* ({ payload }) {
    const { email, password } = payload;
    try {
      const user = yield call(
        FirebaseService.signInEmailRequest,
        email,
        password,
      );
      if (user.message) {
        yield put(showAuthMessage(user.message));
      } else {
        localStorage.setItem(AUTH_TOKEN, user.user.uid);
        yield put(authenticated(user.user.uid));
      }
    } catch (err) {
      yield put(showAuthMessage(err));
    }
  });
}

export function* signInWithEmail() {
  yield takeEvery(SIGNIN_WITH_EMAIL, function* ({ payload }) {
    const { email, password } = payload;
    try {
      yield put(setLoading(true));
      const response = yield call(() => {
        return axios.request({
          method: 'post',
          url: env.API_ENDPOINT_URL + `/auth/login`,
          data: {
            Email: email,
            Password: password,
          },
        });
      });
      const { data: loginData } = response;
      if (loginData.AccessToken) {
        localStorage.setItem(ACCESS_TOKEN, loginData.AccessToken);
        localStorage.setItem(IS_2FA_ENABLED, loginData.Is2FAEnabled);
        localStorage.setItem(EMAIL, loginData.Email);
        yield put(setLoading(false));

        yield put(signInWithEmailAuthenticated(loginData));
      }
    } catch (err) {
      yield put(setLoading(false));

      yield put(
        displayMessage({
          message: err?.response?.data?.message || 'Failed to Login',
          isError: true,
        }),
      );
      // yield put(hideMessage());
    }
  });
}

export function* logout() {
  yield takeEvery(SIGNOUT, function* () {
    try {
      // Logging out
      const response = yield call(() => {
        return axios.request({
          url: env.API_ENDPOINT_URL + '/auth/logout',
          method: 'post',
          withCredentials: true,
        });
      });
      if (response.status == 200) {
        localStorage.clear();
        sessionStorage.clear();
        const cookies = new Cookies();
        cookies.remove('tomei-price-sid', { path: '/' });
      } else {
        throw new Error('Failed to log out');
      }
      yield put(signOutSuccess('Sign Out Successfully'));
      // Redirect to login page after successful logout
      window.location.href = '/auth/login';
    } catch (error) {
      yield put(
        displayMessage({
          message: error.message,
          isError: true,
        }),
      );
    }
  });
}

export function* signUpWithEmail() {
  yield takeEvery(SIGNUP, function* ({ payload }) {
    const { email, password } = payload;
    try {
      const response = yield call(() => {
        return axios.request({
          method: 'post',
          url: env.API_ENDPOINT_URL + `/auth/register`,
          data: {
            Email: email,
            Password: password,
          },
        });
      });
      if (response.data.status === 400) {
        throw new Error(response.data.message);
      }
      const { data: loginData } = response;
      if (loginData.AccessToken) {
        localStorage.setItem(ACCESS_TOKEN, loginData.AccessToken);
        localStorage.setItem(IS_2FA_ENABLED, false);
        localStorage.setItem(EMAIL, loginData.Email);
        yield put(signInWithEmailAuthenticated(loginData));
      }
    } catch (error) {
      yield put(
        displayMessage({
          message: error.message,
          isError: true,
        }),
      );
    }
  });
}

export function* signInWithFBGoogle() {
  yield takeEvery(SIGNIN_WITH_GOOGLE, function* () {
    try {
      const user = yield call(FirebaseService.signInGoogleRequest);
      if (user.message) {
        yield put(showAuthMessage(user.message));
      } else {
        localStorage.setItem(AUTH_TOKEN, user.user.uid);
        yield put(signInWithGoogleAuthenticated(user.user.uid));
      }
    } catch (error) {
      yield put(showAuthMessage(error));
    }
  });
}

export function* signInWithFacebook() {
  yield takeEvery(SIGNIN_WITH_FACEBOOK, function* () {
    try {
      const user = yield call(FirebaseService.signInFacebookRequest);
      if (user.message) {
        yield put(showAuthMessage(user.message));
      } else {
        localStorage.setItem(AUTH_TOKEN, user.user.uid);
        yield put(signInWithFacebookAuthenticated(user.user.uid));
      }
    } catch (error) {
      yield put(showAuthMessage(error));
    }
  });
}

export function* generateQR() {
  yield takeLatest(GENERATE_QR, function* () {
    try {
      yield put(fetchRequested());
      const access_token = localStorage.getItem('access_token'); // PERLU DIGANTI BANG NUR
      const response = yield call(() => {
        return axios.request({
          method: 'get',
          url: env.API_ENDPOINT_URL + '/auth/generate-qr',
          headers: {
            Authorization: `Bearer ${access_token}`,
          },
        });
      });
      const {
        data: { QRData },
      } = response;
      yield put(setQR(QRData));
    } catch (error) {
      // QR fetch error
    } finally {
      yield put(fetchCompleted());
    }
  });
}

export function* verify() {
  yield takeLatest(VERIFY_UNIQUE_KEY, function* (action) {
    try {
      yield put(setLoading(true));
      yield put(fetchRequested());
      const access_token = localStorage.getItem('access_token');
      const response = yield call(() => {
        return axios.request({
          method: 'post',
          url: env.API_ENDPOINT_URL + '/auth/verify-otp',
          headers: {
            Authorization: `Bearer ${access_token}`,
          },
          data: {
            Code: action.uniqueKey.uniqueKey,
          },
        });
      });
      const { data: loginData } = response;
      if (loginData.isVerified === true) {
        localStorage.setItem('AUTH_TOKEN', loginData.AccessToken);
        yield put(userVerified());
        yield put(setLoading(false));
      } else {
        yield put(
          displayMessage({ message: 'Wrong Unique Key', isError: true }),
        );
        yield put(setLoading(false));
      }
    } catch (error) {
      // Verification error
      yield put(setLoading(false));
      yield put(displayMessage({ message: 'Failed to verify', isError: true }));
    } finally {
      yield put(setLoading(false));
      yield put(fetchCompleted());
    }
  });
}

export function* check2FAIsEnabled() {
  yield takeLatest(GET_IS_2FA_ENABLED, function* () {
    try {
      const access_token = localStorage.getItem('access_token');
      const response = yield call(() => {
        return axios.request({
          method: 'get',
          url: env.API_ENDPOINT_URL + '/auth/check-is-2fa-enabled',
          headers: {
            Authorization: `Bearer ${access_token}`,
          },
        });
      });
      const {
        data: { Is2FAEnabled },
      } = response;
      yield put(setIs2FAEnabled(Is2FAEnabled));
    } catch (error) {
      // 2FA check error
    }
  });
}

export function* changePassword() {
  yield takeLatest(CHANGE_PASSWORD, function* (action) {
    try {
      yield put(fetchRequested());
      const access_token = localStorage.getItem('access_token');
      const response = yield call(() => {
        return axios.request({
          method: 'post',
          url: env.API_ENDPOINT_URL + '/auth/change-password',
          headers: {
            Authorization: `Bearer ${access_token}`,
          },
          data: {
            OldPassword: action.password.oldPassword,
            NewPassword: action.password.newPassword,
          },
        });
      });
      if (response.status === 200) {
        yield put(signOut());
        yield put(
          displayMessage({ message: 'Password Changed', isError: false }),
        );
      }
    } catch (error) {
      yield put(
        displayMessage({
          message: error.response.data.message || 'Failed to change password',
          isError: true,
        }),
      );
    } finally {
      yield put(fetchCompleted());
    }
  });
}

export function* getUserProfile() {
  yield takeLatest(GET_USER_PROFILE, function* (payload) {
    try {
      yield put(fetchRequested());
      const response = yield call(() => {
        return axios.request({
          method: 'post',
          url: env.API_ENDPOINT_URL + '/auth/get-user-profile',
          withCredentials: true,
        });
      });
      let profilePicture = null;
      try {
        profilePicture = yield call(() => {
          return axios.request({
            method: 'post',
            url: env.SSO_API_URL + '/users/get-profile-picture',
            responseType: 'blob',
            withCredentials: true,
          });
        });
      } catch (error) {}
      sessionStorage.setItem('profile', JSON.stringify(response.data));
      const { data: profile } = response;
      yield put(
        setUserProfile({
          ...profile,
          profilePicture: profilePicture
            ? URL.createObjectURL(profilePicture.data)
            : null,
        }),
      );
      yield put(authenticated(profile));
    } catch (error) {
      localStorage.clear();
      const cookies = new Cookies();
      cookies.remove('tomei-price-sid', { path: '/' });
      // Don't redirect here - let the FetchInterceptor handle it
      // or let the Views component handle the redirect based on token state
      yield put(signOutSuccess());
    } finally {
      yield put(fetchCompleted());
    }
  });
}

export default function* rootSaga() {
  yield all([
    fork(signInWithFBEmail),
    fork(signInWithEmail),
    fork(logout),
    fork(signUpWithEmail),
    fork(signInWithFBGoogle),
    fork(signInWithFacebook),
    fork(generateQR),
    fork(verify),
    fork(check2FAIsEnabled),
    fork(changePassword),
    fork(getUserProfile),
  ]);
}
